export class SortData {
  activeColumn: string;
  order: string;
}
